import { t } from '../../app/i18n';

export default {
  WHATEVER: 'WHATEVER',
  VACATION: 'VACATION',
  CAR: 'CAR',
  EXPENSES: 'EXPENSES',
  HOUSE: 'HOUSE',
};

export const translation = {
  WHATEVER: t('čokoľvek'),
  VACATION: t('dovolenku'),
  CAR: t('nové auto'),
  EXPENSES: t('nečakané výdavky'),
  HOUSE: t('nové bývanie'),
};



// WEBPACK FOOTER //
// ./src/common/enums/loanGoals.js